// extracted by mini-css-extract-plugin
export default {"links":"Navbar_links__HMQUC","name":"Navbar_name__Zdh91"};